import { MagnifyingGlass, X } from "@phosphor-icons/react";

export const GameSearchBar = ({ value, onChange }) => (
  <div data-testid="line-movement-search-bar" className="flex flex-col gap-1">
    <div className="relative flex items-center">
      <MagnifyingGlass size={14} className="pointer-events-none absolute left-3 text-zinc-500" />
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Search team, matchup, or league..."
        data-testid="line-movement-search-input"
        className="w-full rounded-md border border-white/10 bg-eb-bg py-2 pl-9 pr-9 font-mono text-xs text-zinc-200 placeholder:text-zinc-600 focus:border-eb-accent focus:outline-none"
      />
      {value && (
        <button
          type="button"
          onClick={() => onChange("")}
          data-testid="line-movement-search-clear"
          aria-label="Clear search"
          className="absolute right-2.5 text-zinc-500 transition-colors hover:text-zinc-200"
        >
          <X size={14} />
        </button>
      )}
    </div>
    <span className="font-mono text-[10px] text-zinc-600">Searches only currently loaded games.</span>
  </div>
);
